import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
const rows = [{
  bad: 'Falta de energía diaria',
  good: 'Más vitalidad y motivación'
}, {
  bad: 'Rutinas abandonadas',
  good: 'Constancia real'
}, {
  bad: 'Baja autoestima',
  good: 'Más confianza personal'
}, {
  bad: 'Sedentarismo',
  good: 'Hábitos saludables'
}, {
  bad: 'Estrés y cansancio',
  good: 'Mejor bienestar mental'
}, {
  bad: 'Confusión sobre qué hacer',
  good: 'Sistema paso a paso'
}, {
  bad: 'Falta de disciplina',
  good: 'Organización y enfoque'
}, {
  bad: 'Siempre empezar de cero',
  good: 'Progreso sostenible'
}];
export function Comparison() {
  return <section className="py-10 md:py-20 px-4" data-id="element-37">
      <div className="max-w-4xl mx-auto" data-id="element-38">
        <div className="text-center mb-6 md:mb-12" data-id="element-39">
          <div className="text-zinc-500 font-bold tracking-widest uppercase text-[10px] md:text-sm mb-1 md:mb-2" data-id="element-40">
            LA REALIDAD
          </div>
          <h2 className="text-3xl md:text-6xl font-bebas text-white leading-tight" data-id="element-41">
            ¿CUÁNTO CUESTA NO CAMBIAR?
          </h2>
        </div>

        <div className="bg-zinc-900 border border-zinc-800 rounded-xl md:rounded-2xl overflow-hidden" data-id="element-42">
          <div className="grid grid-cols-2 border-b border-zinc-800" data-id="element-43">
            <div className="p-2.5 md:p-6 text-center bg-zinc-950/50" data-id="element-44">
              <div className="text-red-500 font-bold text-xs md:text-xl flex items-center justify-center gap-1.5" data-id="element-45">
                SIN EL SISTEMA <X className="w-3.5 h-3.5 md:w-5 md:h-5" data-id="element-46" />
              </div>
            </div>
            <div className="p-2.5 md:p-6 text-center bg-brand-500/10" data-id="element-47">
              <div className="text-brand-500 font-bold text-xs md:text-xl flex items-center justify-center gap-1.5" data-id="element-48">
                CON ENTRENA EN CASA{' '}
                <Check className="w-3.5 h-3.5 md:w-5 md:h-5" data-id="element-49" />
              </div>
            </div>
          </div>

          <div className="divide-y divide-zinc-800/50" data-id="element-50">
            {rows.map((row, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.04
          }} className="grid grid-cols-2" data-id="element-51">
                <div className="px-2 py-2.5 md:p-5 text-center text-zinc-400 text-[11px] md:text-base bg-zinc-950/30 flex items-center justify-center leading-tight" data-id="element-52">
                  {row.bad}
                </div>
                <div className="px-2 py-2.5 md:p-5 text-center text-white font-medium text-[11px] md:text-base bg-brand-500/5 flex items-center justify-center leading-tight" data-id="element-53">
                  {row.good}
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}